module.exports = __webpack_public_path__ + "img/sand-dune-decal-03.8eb5b559.png";